import Rest from '../rest'

/******************************************************************************
 *  AvailabilityTransfer
 *****************************************************************************/

/**
 * @type {AvailabilityTransfer}
 */
export default class AvailabilityTransfer extends Rest {
    constructor () {
        super('/availability/transfer')
    }

    postAvailabilityTransferReserves(reservesId, data) {
        return this.createV2(`reserves/${reservesId}`, data)
    }
}